import { map, get, pick } from "lodash"
import { createSelector } from "reselect"
import { getIsSuperuser } from "modules/account-root/selectors"
import { getRoute, getPath } from "selectors/urls"
import { computeDatasetPermissionsTabs } from "helpers/permissions/tabs"

const getDatasetEntitlements = (state) => get(state, "global.data.datasetEntitlements.data")

export const getDatasetEntities = createSelector(
  [getDatasetEntitlements],
  (entitlements) => map(entitlements, ({ member, token, type, direct, teams }) => ({
    ...pick(member || token, ["id", "name"]),
    type,
    direct,
    teams,
  }),
  ),
)

export const getTabs = createSelector(
  [getRoute, getPath, getIsSuperuser],
  computeDatasetPermissionsTabs,
)
